import i18n from 'i18next'
import merge from 'lodash/merge'
import { initReactI18next } from 'react-i18next'

import { isVelthuis } from '@/utils/common'
import {
  DEFAULT_LANGUAGE,
  Language,
  supportedLangs,
} from '~common/constants.js'

import enCommon from './locales/common/en'
import nlCommon from './locales/common/nl'
import enVelthuis from './locales/velthuis/en'
import nlVelthuis from './locales/velthuis/nl'
import enXpert from './locales/xpert/en'
import nlXpert from './locales/xpert/nl'

const translations = isVelthuis
  ? { en: enVelthuis, nl: nlVelthuis }
  : { en: enXpert, nl: nlXpert }

const resources = {
  [Language.en]: {
    translation: merge(enCommon, translations.en),
  },
  [Language.nl]: {
    translation: merge(nlCommon, translations.nl),
  },
}

i18n.use(initReactI18next).init({
  debug: true,
  defaultNS: 'translation',
  fallbackLng: DEFAULT_LANGUAGE,
  lng: supportedLangs.includes(navigator.language as Language)
    ? navigator.language
    : DEFAULT_LANGUAGE,
  load: 'currentOnly',
  resources,
  supportedLngs: supportedLangs,
})

export type { Language }

export default i18n
